import script from "./Flows.vue?vue&type=script&setup=true&lang=js"
export * from "./Flows.vue?vue&type=script&setup=true&lang=js"

import "./Flows.vue?vue&type=style&index=0&id=16c281b6&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16c281b6"]])

export default __exports__